"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOfDesignEvaluationConsiderations = exports.noProcessName = exports.hasRoMMInRisk = exports.hasThreeCategories = exports.getControlClass = exports.getProjectId = void 0;
var DayouControl_1 = __importDefault(require("../data/control/DayouControl"));
var HelixmithControl_1 = __importDefault(require("../data/control/HelixmithControl"));
var LegacyControl_1 = __importDefault(require("../data/control/LegacyControl"));
var TPCControl_1 = __importDefault(require("../data/control/TPCControl"));
function getProjectId() {
    var projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
    if (projectId === 'icfr-9e07f') {
        return 'pergg';
    }
    else if (projectId === 'ia-kth-test') {
        return 'ia-kth-test';
    }
    else if (projectId === 'icfr-tmon') {
        return 'tmon';
    }
    else if (projectId === 'icfr-meerecompany') {
        return 'meere';
    }
    else if (projectId === 'icfr-dayouplus') {
        return 'dayouplus';
    }
    else if (projectId === 'icfr-tpc') {
        return 'tpc';
    }
    else if (projectId === 'icfr-helixmith') {
        return 'helixmith';
    }
    else {
        return 'default';
    }
}
exports.getProjectId = getProjectId;
function getControlClass() {
    var projectId = getProjectId();
    if (projectId === 'dayouplus') {
        return DayouControl_1.default;
    }
    if (projectId === 'tpc') {
        return TPCControl_1.default;
    }
    if (projectId === 'helixmith') {
        return HelixmithControl_1.default;
    }
    return LegacyControl_1.default;
}
exports.getControlClass = getControlClass;
function hasThreeCategories() {
    return process.env.REACT_APP_HAS_THREE_CATEGORIES === 'True';
}
exports.hasThreeCategories = hasThreeCategories;
// TODO(sangmuk): Consider to use AbstractRisk with below function.
function hasRoMMInRisk() {
    return process.env.REACT_APP_HAS_ROMM_IN_RISK === 'True';
}
exports.hasRoMMInRisk = hasRoMMInRisk;
// TODO(sangmuk): Consider to create AbstractProcess with below function.
function noProcessName() {
    return process.env.REACT_APP_NO_PROCESS_NAME === 'True';
}
exports.noProcessName = noProcessName;
function getNumberOfDesignEvaluationConsiderations() {
    var projectId = getProjectId();
    if (projectId === 'tmon' || projectId === 'meere') {
        return 3;
    }
    return 5;
}
exports.getNumberOfDesignEvaluationConsiderations = getNumberOfDesignEvaluationConsiderations;
//# sourceMappingURL=Config.js.map